import { ActionButton, ActionButtonProps } from 'modules/ui/atoms/ActionButton'
import useFlow from '../../../state/use-flow'
import { trackFormSubmitEvent } from '../../../../analytics/helpers/track-form-events'
import useOrder from '../../../../order/state/order/use-order'
import { getClassySessionId } from 'modules/utils/getClassySessionId'
import { getCookieValue } from 'modules/utils/getCookieValue'
import { PaymentMethodConfig } from '../utils/payment-method-configs'
import useConfig from '../../../../config/state/use-config'
import useTrackUIElementEvent from '../../../../analytics/hooks/useTrackUIElementEvent'
import mParticleSdk from '@mparticle/web-sdk'

export type PaymentSelectionButtonProps = ActionButtonProps & {
  paymentMethodConfig: PaymentMethodConfig
}

const PaymentSelectionButton = (props: PaymentSelectionButtonProps) => {
  const flow = useFlow()
  const order = useOrder()
  const config = useConfig()
  const trackUIElementEvent = useTrackUIElementEvent()

  const onNext = () => {
    trackFormSubmitEvent(flow.currentStep.name, { payment_type: order.paymentDetails.type })

    // Track mParticle "Button Clicked" event for proceeding to payment details
    trackUIElementEvent('Button Clicked', mParticleSdk.EventType.Other, {
      tracking_id: 'proceed to payment details',
      text: 'Continue',
      link_url: typeof window !== 'undefined' ? window.location.href : '',
      outbound: false,
    })

    if (typeof window !== 'undefined' && window.newrelic) {
      window.newrelic.addPageAction('payment_method_selected', {
        pgdid: getCookieValue('pgdid'),
        'classy-session-id': getClassySessionId(),
        paymentMethod: order.paymentDetails.type,
      })
    }

    flow.nextStep && flow.goToStep(flow.nextStep.name)
  }

  return (
    <ActionButton
      onClick={onNext}
      {...props}
      size="lg"
      color={config.theme['--theme-color__brand-primary']}
    />
  )
}

export default PaymentSelectionButton
